import { Card, CardContent, Typography, Box, Divider } from "@mui/material";
import { Study } from "@api/Models";
import { useTranslation } from "react-i18next";

interface EducationProps {
  study: Study;
}

export function Education({ study }: EducationProps) {
  const { t } = useTranslation();

  return (
    <section className="mb-8">
      <Typography variant="h3" className="text-2xl font-semibold mb-4">
        {t("education")}
      </Typography>
      <Card className="mb-6 hover:shadow-2xl">
        <CardContent>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h5" component="div">
              {study.title}
            </Typography>
            <Typography color="text.secondary" gutterBottom>
              {study.university}
            </Typography>
          </Box>
          <Typography color="text.secondary" gutterBottom>
            {study.start_date} - {study.end_date}
          </Typography>
          <Divider textAlign="left">{t("relevant_projects")}</Divider>
          <ul className="list-disc list-inside mb-2">
            {study.projects.map((resp, index) => (
              <li key={index} className="text-sm mb-1">
                {resp}
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  );
}
